var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ItpPage",
    {
      attrs: {
        "no-primary-button": "",
        closeButtonText: _vm._f("gettext")("Close"),
        size: _vm.size,
        header: _vm.documentTitle,
        loaded: _vm.loaded,
        noShow: !_vm.loaded,
        modal: _vm.modal,
        "itp-cname": "BulkContractServiceEditor",
        modalBindings: _vm.b_7315092382398562_modalBindings
      },
      on: {
        close: function($event) {
          return _vm.evh_7315092382398562_close($event, {})
        }
      }
    },
    [
      _vm.loaded
        ? _c("UcHeader", {
            attrs: {
              slot: "header",
              card: !_vm.modal,
              modal: _vm.modal,
              title: _vm.documentTitle
            },
            on: {
              close: function($event) {
                return _vm.evh_2248226175642056_close($event, {})
              }
            },
            slot: "header"
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.loaded
        ? _c(
            "UcBody",
            { attrs: { card: !_vm.modal, modal: _vm.modal } },
            [
              _c(
                "ItpForm",
                {
                  ref: "mainForm",
                  staticClass: "row",
                  attrs: { id: _vm.formId, name: "contract" },
                  on: {
                    submit: function($event) {
                      return _vm.evh_1040167445267876_submit($event, {})
                    }
                  }
                },
                [
                  _c(
                    "ItpCol",
                    [
                      _c(
                        "ItpFormGroup",
                        {
                          attrs: {
                            name: "service",
                            label: _vm._f("pgettext")(
                              "Service",
                              "ContractService"
                            ),
                            labelColsMd: "3",
                            contentColsMd: "9",
                            labelAlign: _vm.labelAlign,
                            helpTooltip: _vm._f("pgettext")(
                              "Select the product or service the invoice line refers to.",
                              "ContractService|Tooltip"
                            )
                          }
                        },
                        [
                          _c("ItpFormSelect2", {
                            attrs: {
                              name: "client",
                              "bind-object": "",
                              options: _vm.services,
                              textField: "name"
                            },
                            on: {
                              optionSelected: function($event) {
                                return _vm.evh_5731695935601903_optionSelected(
                                  $event,
                                  {}
                                )
                              }
                            },
                            model: {
                              value: _vm.item.service,
                              callback: function($$v) {
                                _vm.$set(_vm.item, "service", $$v)
                              },
                              expression: "item.service"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "ItpFormGroup",
                        {
                          attrs: {
                            labelColsMd: "3",
                            contentColsMd: "9",
                            name: "invoice_group_id",
                            label: _vm._f("pgettext")(
                              "Invoice Group",
                              "ContractService"
                            ),
                            labelAlign: _vm.labelAlign,
                            helpTooltip: _vm._f("pgettext")(
                              "The invoice group this service belongs to.",
                              "ContractService|Tooltip"
                            )
                          }
                        },
                        [
                          _c("ItpFormSelect2", {
                            attrs: {
                              name: "invoice_group_id",
                              multiple: _vm.b_3054425420812800_multiple,
                              options: _vm.invoiceGroups,
                              valueField: "id",
                              textField: "name",
                              clearable: ""
                            },
                            model: {
                              value: _vm.item.invoice_group_id,
                              callback: function($$v) {
                                _vm.$set(_vm.item, "invoice_group_id", $$v)
                              },
                              expression: "item.invoice_group_id"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "ItpFormGroup",
                        {
                          attrs: {
                            labelColsMd: "3",
                            name: "intermediated_service",
                            label: _vm._f("pgettext")(
                              "Intermediated service",
                              "ContractService"
                            ),
                            labelAlign: _vm.labelAlign,
                            helpTooltip: _vm._f("pgettext")(
                              "Select this option if the service is provided via an intermediary party.",
                              "ContractService|Tooltip"
                            )
                          }
                        },
                        [
                          _c("ItpFormCheckbox", {
                            attrs: { name: "intermediated_service" },
                            model: {
                              value: _vm.item.intermediated_service,
                              callback: function($$v) {
                                _vm.$set(_vm.item, "intermediated_service", $$v)
                              },
                              expression: "item.intermediated_service"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "ItpFormGroup",
                        {
                          attrs: {
                            name: "valid_to",
                            label: _vm._f("pgettext")(
                              "Description",
                              "ContractService"
                            ),
                            labelColsMd: "3",
                            contentColsMd: "9",
                            labelAlign: _vm.labelAlign,
                            helpTooltip: _vm._f("pgettext")(
                              "Internal notes for reference only. Not visible externally.",
                              "ContractService|Tooltip"
                            )
                          }
                        },
                        [
                          _c("ItpFormTextarea", {
                            attrs: { name: "description", rows: "5" },
                            model: {
                              value: _vm.item.description,
                              callback: function($$v) {
                                _vm.$set(_vm.item, "description", $$v)
                              },
                              expression: "item.description"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("hr"),
                      _vm._v(" "),
                      _c(
                        "fieldset",
                        [
                          _c("legend", [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  _vm._f("pgettext")(
                                    "Invoicing",
                                    "ContractServiceEditor|Section"
                                  )
                                ) +
                                "\n          "
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "ItpFormGroup",
                            {
                              attrs: {
                                name: "name",
                                label: _vm._f("pgettext")(
                                  "Name",
                                  "ContractService"
                                ),
                                labelColsMd: "3",
                                contentColsMd: "9",
                                labelAlign: _vm.labelAlign,
                                helpTooltip: _vm._f("pgettext")(
                                  "This text will appear on the invice line.",
                                  "ContractService|Tooltip"
                                )
                              }
                            },
                            [
                              _c("ItpFormInput", {
                                attrs: { name: "name" },
                                model: {
                                  value: _vm.item.name,
                                  callback: function($$v) {
                                    _vm.$set(_vm.item, "name", $$v)
                                  },
                                  expression: "item.name"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "ItpFormGroup",
                            {
                              attrs: {
                                name: "invoice_notes",
                                label: _vm._f("pgettext")(
                                  "Invoice notes",
                                  "ContractServiceFee"
                                ),
                                labelColsMd: "3",
                                contentColsMd: "9",
                                labelAlign: _vm.labelAlign,
                                helpTooltip: _vm._f("pgettext")(
                                  "Note to display on the invoice line.",
                                  "ContractService|Tooltip"
                                )
                              }
                            },
                            [
                              _c("ItpFormTextarea", {
                                attrs: { name: "fee_notes" },
                                model: {
                                  value: _vm.item.invoice_notes,
                                  callback: function($$v) {
                                    _vm.$set(_vm.item, "invoice_notes", $$v)
                                  },
                                  expression: "item.invoice_notes"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "ItpFormGroup",
                            {
                              attrs: {
                                name: "billing_frequency",
                                label: _vm._f("pgettext")(
                                  "Billing frequency",
                                  "ContractService"
                                ),
                                labelColsMd: "3",
                                contentColsMd: "3",
                                labelAlign: _vm.labelAlign,
                                helpTooltip: _vm._f("pgettext")(
                                  "The cycle length of issuing the invoices.",
                                  "ContractService|Tooltip"
                                )
                              }
                            },
                            [
                              _c("BillingFrequencySelector", {
                                model: {
                                  value: _vm.item.billing_frequency,
                                  callback: function($$v) {
                                    _vm.$set(_vm.item, "billing_frequency", $$v)
                                  },
                                  expression: "item.billing_frequency"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "ItpFormGroup",
                            {
                              attrs: {
                                name: "billing_date_rule",
                                label: _vm._f("pgettext")(
                                  "Billing date rule",
                                  "ContractService"
                                ),
                                labelColsMd: "3",
                                contentColsMd: "9",
                                labelAlign: _vm.labelAlign,
                                helpTooltip: _vm._f("pgettext")(
                                  "The cycle length of issuing the invoices.",
                                  "ContractService|Tooltip"
                                )
                              }
                            },
                            [
                              _c("BillingDateRuleFields", {
                                model: {
                                  value: _vm.item.billing_date_rule,
                                  callback: function($$v) {
                                    _vm.$set(_vm.item, "billing_date_rule", $$v)
                                  },
                                  expression: "item.billing_date_rule"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "ItpFormGroup",
                            { attrs: { labelColsMd: "3", contentColsMd: "9" } },
                            [_c("hr", { staticClass: "dots" })]
                          ),
                          _vm._v(" "),
                          _c(
                            "ItpFormGroup",
                            {
                              attrs: {
                                name: "due_date_rule",
                                label: _vm._f("pgettext")(
                                  "Due date rule",
                                  "ContractService"
                                ),
                                labelColsMd: "3",
                                contentColsMd: "9",
                                labelAlign: _vm.labelAlign,
                                helpTooltip: _vm._f("pgettext")(
                                  "The rule of calculating the payment dates.",
                                  "ContractService|Tooltip"
                                )
                              }
                            },
                            [
                              _c("DueDateRuleFields", {
                                model: {
                                  value: _vm.item.due_date_rule,
                                  callback: function($$v) {
                                    _vm.$set(_vm.item, "due_date_rule", $$v)
                                  },
                                  expression: "item.due_date_rule"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "ItpFormGroup",
                            { attrs: { labelColsMd: "3", contentColsMd: "9" } },
                            [_c("hr", { staticClass: "dots" })]
                          ),
                          _vm._v(" "),
                          _c(
                            "ItpFormGroup",
                            {
                              attrs: {
                                name: "billing_currency",
                                label: _vm._f("pgettext")(
                                  "Billing currency",
                                  "ContractService"
                                ),
                                labelColsMd: "3",
                                contentColsMd: "3",
                                labelAlign: _vm.labelAlign,
                                helpTooltip: _vm._f("pgettext")(
                                  "The currency to use on the invoice.",
                                  "ContractService|Tooltip"
                                )
                              }
                            },
                            [
                              _c("BillingCurrencySelector", {
                                model: {
                                  value: _vm.item.billing_currency,
                                  callback: function($$v) {
                                    _vm.$set(_vm.item, "billing_currency", $$v)
                                  },
                                  expression: "item.billing_currency"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "ItpFormGroup",
                            {
                              attrs: {
                                name: "exchange_rate_source",
                                label: _vm._f("pgettext")(
                                  "Exchange rate source",
                                  "ContractService"
                                ),
                                labelColsMd: "3",
                                contentColsMd: "3",
                                labelAlign: _vm.labelAlign,
                                helpTooltip: _vm._f("pgettext")(
                                  "The currency exchange rate's provider.",
                                  "ContractService|Tooltip"
                                )
                              }
                            },
                            [
                              _c("ExchangeRateSourceSelector", {
                                model: {
                                  value: _vm.item.exchange_rate_source,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.item,
                                      "exchange_rate_source",
                                      $$v
                                    )
                                  },
                                  expression: "item.exchange_rate_source"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "ItpFormGroup",
                            {
                              attrs: {
                                name: "exchange_rate_date_rule",
                                label: _vm._f("pgettext")(
                                  "Exchange rate date rule",
                                  "ContractService"
                                ),
                                labelColsMd: "3",
                                contentColsMd: "9",
                                labelAlign: _vm.labelAlign,
                                helpTooltip: _vm._f("pgettext")(
                                  "The date used to determine the exchange rate for billing purposes.",
                                  "ContractService|Tooltip"
                                )
                              }
                            },
                            [
                              _c("ExchangeRateDateRuleFields", {
                                model: {
                                  value: _vm.item.exchange_rate_date_rule,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.item,
                                      "exchange_rate_date_rule",
                                      $$v
                                    )
                                  },
                                  expression: "item.exchange_rate_date_rule"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.loaded
        ? _c(
            "UcFooter",
            {
              attrs: { slot: "footer", card: !_vm.modal, modal: _vm.modal },
              slot: "footer"
            },
            [
              _c("ItpButton", {
                attrs: {
                  text: _vm._f("pgettext")("Save", "Button"),
                  disabled:
                    !_vm.forms.contract || !_vm.forms.contract.submittable,
                  type: "submit",
                  form: _vm.formId,
                  variant: "primary",
                  icon: "fa-save",
                  spinning: _vm.actions.save.isRunning
                }
              }),
              _vm._v(" "),
              _c("ItpButton", {
                attrs: { text: _vm._f("gettext")("Close"), variant: "default" },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    $event.stopPropagation()
                    return _vm.evh_1419464017721962_clickPreventStop($event, {})
                  }
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.loaded ? _c("template", { slot: "footer" }) : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }